import styles from "./FormStyles.module.css";
import PropTypes from "prop-types";

// --| This component will be used as a text area for every forms used. it returns a label and input with props
const TextAreaGroup = ({ label, inputName, defaultValue, value, onChange, placeHolder, disabled, required }) => (
  <div className={styles.areawrapper}>
    <p>{label} {required ? <span className="input-required">*</span> : null}</p>
    <textarea defaultValue={defaultValue} value={value} name={inputName} onChange={onChange} placeholder={placeHolder} disabled={disabled} />
  </div>
);
TextAreaGroup.propTypes = {
  inputType: PropTypes.string,
  label: PropTypes.string
};
export default TextAreaGroup;
